// import { all_locales, all_providers } from "./data";
function proxy() {
    return "";
}
// Search for an Item (either a show or movie title) in a locale/country (ex. "en_US" for USA)
export async function search_for_item(query, country) {
    console.log(proxy());
    const url = `https://cors.wannaflix.net/https://apis.justwatch.com/content/titles/${country}/popular`;
    const body = {
        "query": query,
    };
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
            "X-Requested-With": "fetch"
        }
    });
    if (response.ok == false)
        throw new Error("Http Error: " + response.status);
    return await response.json();
}
// Returns raw JSON information on every locale supported by JustWatch
async function get_locales() {
    const url = "https://cors.wannaflix.net/https://apis.justwatch.com/content/locales/state";
    const response = await fetch(url, {
        headers: { "X-Requested-With": "fetch" }
    });
    if (response.ok == false)
        throw new Error("Http Error: " + response.status);
    return await response.json();
}
export class Locale {
    constructor(country, full_locale) {
        this.country = country;
        this.full_locale = full_locale;
    }
}
/*
Returns the usable information about every JustWatch supported locale,
the property for key 'full_locale' is the one usable for API requests.
ex. en_US
*/
export async function get_all_locales() {
    const locales = await get_locales();
    var all_locales = [];
    locales.forEach((i) => {
        var l = new Locale(i.country, i.full_locale);
        all_locales.push(l);
    });
    return all_locales;
}
// Returns JSON data on every provider JustWatch has data on for a given locale/country
async function get_providers(country) {
    const url = `https://cors.wannaflix.net/https://apis.justwatch.com/content/providers/locale/${country}`;
    const response = await fetch(url, {
        headers: { "X-Requested-With": "fetch" }
    });
    if (response.ok == false)
        throw new Error("Http Error: " + response.status);
    return response.json();
}
// Returns the JSON data on every single provider JustWath has data on for every country
export async function get_all_providers() {
    const locale_list = await get_all_locales();
    var providers_array = [];
    var promise = locale_list.map(async (locale) => {
        var r = await get_providers(locale.full_locale);
        var provider = {
            country: locale.country,
            providers: r
        };
        providers_array.push(provider);
    });
    await Promise.all(promise);
    return providers_array;
}
/*
Returns JustWatch's data for a given show or movie for a given locale.
content_type is either "show" or "movie"
*/
export async function get_title_from_id(title_id, country, content_type) {
    const url = `https://cors.wannaflix.net/https://apis.justwatch.com/content/titles/${content_type}/${title_id}/locale/${country}`;
    const response = await fetch(url, {
        headers: { "X-Requested-With": "fetch" }
    });
    if (response.ok == false)
        throw new Error("Http Error: " + response.status);
    return response.json();
}
export class IDSearch {
    constructor(title, id, poster_uri, type, release_year, query_locale) {
        this.title = title;
        this.id = id;
        this.poster_uri = poster_uri;
        this.type = type;
        this.release_year = release_year;
        this.query_locale = query_locale;
    }
}
// Returns the most useful data from a search query as an array of IDSearch objects.
// IDSearch's properties are the title of the movie or show, JustWatch's id for that movie or show, 
// the URL of that movie or show's poster, the type (show or movie), the release year, and the Locale 
// object used to make the search
export async function search_for_item_id(query, locale) {
    const r = await search_for_item(query, locale.full_locale);
    var titles = [];
    r["items"].forEach((i) => {
        let regex = new RegExp("\\s*([0-9]+)");
        var regex_match = regex.exec(i["poster"]);
        var poster_uri;
        if (regex_match == null) {
            poster_uri = "NULL";
        }
        else {
            poster_uri = `https://images.justwatch.com/poster/${regex_match[0]}/s592/poster.webp`;
        }
        titles.push(new IDSearch(i["title"], i["id"], poster_uri, i["object_type"], i["original_release_year"], locale));
    });
    return titles;
}
